import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { deepResearchService } from "@/lib/services";

export function SharedDeepResearchRedirect() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      navigate("/deep-research", { replace: true });
      return;
    }

    const accessLink = async () => {
      try {
        const response = await deepResearchService.accessShareLink(token);
        navigate(`/deep-research/${response.data.uuid}`, { replace: true });
      } catch (err: unknown) {
        console.error("Failed to access shared deep research link:", err);
        const errObj = err as Record<string, unknown> | undefined;
        const detail = (errObj?.data as Record<string, unknown> | undefined)?.detail;
        setError(typeof detail === "string" ? detail : "This share link is invalid or has been deactivated.");
      }
    };

    accessLink();
  }, [token, navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center p-8">
        <div className="w-16 h-16 bg-red-500/20 rounded-2xl flex items-center justify-center mb-4">
          <span className="text-3xl">!</span>
        </div>
        <h2 className="text-xl font-bold text-content-primary mb-2">Unable to access shared research</h2>
        <p className="text-content-tertiary max-w-md mb-6">{error}</p>
        <button
          onClick={() => navigate("/deep-research")}
          className="px-4 py-2 bg-surface-secondary hover:bg-interactive-active text-content-primary rounded-lg transition border border-border-secondary"
        >
          Go to Deep Research
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-full">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="w-8 h-8 text-brand-primary animate-spin" />
        <p className="text-content-tertiary text-sm">Accessing shared research...</p>
      </div>
    </div>
  );
}
